import classNames from 'classnames';
import { TooltipDirection, TooltipSize } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';
import { ScopedTooltip } from '../TooltipDecorator/ScopedTooltip';

import './HintInfo.css';

export enum HintInfoType {
    info = 'info',
    alert = 'alert'
}

export interface HintInfoProps {
    text: string;
    caption?: string;
    cls?: string;
    to?: Array<TooltipDirection> | TooltipDirection;
    size?: TooltipSize;
    type?: HintInfoType;
    theme?: Shape2Theme;
    zIndexGroupLevel?: number;
}

interface HintInfoState {
    isHintVisible: boolean;
}

const BLOCK = 'hint-info';

export class HintInfo extends React.PureComponent<HintInfoProps, HintInfoState> {
    constructor(props: HintInfoProps) {
        super(props);

        this.state = {
            isHintVisible: false
        };
    }

    render() {
        const { theme = Shape2Theme.default, type = HintInfoType.info, caption, cls } = this.props;

        return (
            <span
                className={classNames(cls, Bem.cls(BLOCK, '', { type }))}
                onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}
            >
                {caption && <span className={Bem.cls(BLOCK, 'caption')}>{caption}</span>}
                <Shape2 icon={Shape2Icon.info} width={12} height={12} theme={theme} />
                {this.getHintContent()}
            </span>
        );
    }

    private getHintContent() {
        const { text, size = 'l', zIndexGroupLevel, to } = this.props;

        if (!text) {
            return null;
        }

        return (
            <ScopedTooltip
                cls={Bem.cls(BLOCK, 'popup')}
                theme={'white'}
                anchor={this}
                visible={this.state.isHintVisible}
                tail={true}
                view={'classic'}
                size={size}
                offset={0}
                to={to}
                zIndexGroupLevel={zIndexGroupLevel}
            >
                <span className={Bem.cls(BLOCK, 'text')}>{text}</span>
            </ScopedTooltip>
        );
    }

    private onMouseEnterHandler = () => {
        if (!this.props.text) {
            return;
        }

        this.setState({
            isHintVisible: true
        });
    };

    private onMouseLeaveHandler = () => {
        if (!this.props.text) {
            return;
        }

        this.setState({
            isHintVisible: false
        });
    };
}
